import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { Parallax } from 'react-scroll-parallax';

import Wrapper from '../elements/wrapper';
import { media } from '../helpers';

import Wave from '../../images/waves/home-top-wave.inline.svg';

const ProductContentRowsContainer = styled.div`
    background-color: #f2f0eb;
    padding-bottom: 100px;

    &.no-pad {
        padding-bottom: 0;
    }
    .svg-container {
        background-color: #f2f0eb;

        svg {
            width: 100%;
            height: auto;

            path {
                mask: none;
                opacity: 1;
                fill: #fff;
            }
        }
    }

    > .content-container {
        text-align: center;
        padding: 100px 0 70px;
        position: relative;

        ${media.medium`max-width: 650px; top: -10vh;margin-bottom: -10vh; padding: 100px 0 70px;`}

        h3 {
            font-size: 2.2rem;
            margin: 0 0 20px;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            color: #000;
            ${media.large`font-size: 2.6rem;`}
        }

        p {
            font-size: 0.9rem;
        }
    }

    .content-row-wrapper {
        ${media.medium`display: flex; max-width: 70vw;`}
        margin-bottom: 70px;

        &.flipped {
            .image-container {
                order: 2;
            }
            .content-container {
                order: 1;
            }
        }

        &:last-child {
            margin-bottom: 0px;
        }

        .image-container {
            flex: 1;
        }
        > .content-container {
            flex: 1;
            display: flex;
            align-items: center;

            .inner-wrap {
                max-width: 450px;
                margin: 0 auto;
                padding: 20px 10px 0;

                h3 {
                    font-size: 2rem;
                    font-family: neue-kabel, sans-serif;
                    color: #000;
                    margin: 0 0 15px;
                    line-height: 1.3;
                    font-weight: 800;
                    ${media.large`font-size: 2.6rem; line-height: 1;`};
                }

                p {
                    font-size: 1.1rem;
                    line-height: 1.5;
                }
            }
        }
    }
`;

const ProductContentRows = ({ pdp_acf }) => {
    const { productDescriptionTitle, productDescription, productContentRows } =
        pdp_acf || {};

    function generateDescription() {
        return { __html: productDescription };
    }

    function isOdd(num) {
        return num % 2;
    }

    return (
        <ProductContentRowsContainer
            className={
                !productDescriptionTitle && !productDescription ? 'no-pad' : ''
            }
        >
            <div className="svg-container">
                {/* <Parallax
                    className="custom-class"
                    y={[-40, 20]}
                    // x={[-40, 20]}
                    tagOuter="figure"
                >
                </Parallax> */}
                <Wave />
            </div>

            {productDescriptionTitle && productDescription && (
                <Wrapper className="content-container">
                    <h3>{productDescriptionTitle}</h3>
                    <div
                        className="content"
                        dangerouslySetInnerHTML={generateDescription()}
                    ></div>
                </Wrapper>
            )}
            {productContentRows &&
                productContentRows.map((row, index) => {
                    const {
                        contentRowImage,
                        contentRowTitle,
                        contentRowDescription,
                    } = row || {};

                    let isProductOdd = isOdd(index);

                    return (
                        <Wrapper
                            className={
                                !isProductOdd
                                    ? 'content-row-wrapper flipped'
                                    : 'content-row-wrapper'
                            }
                        >
                            <div className="image-container">
                                <Img
                                    fluid={
                                        contentRowImage.localFile
                                            .childImageSharp.fluid
                                    }
                                />
                            </div>
                            <div className="content-container">
                                <div className="inner-wrap">
                                    <h3>{contentRowTitle}</h3>
                                    <p>{contentRowDescription}</p>
                                </div>
                            </div>
                        </Wrapper>
                    );
                })}
        </ProductContentRowsContainer>
    );
};

export default ProductContentRows;
